import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 md:py-20 px-4 bg-brand-dark" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-green border-2 border-gold rounded-3xl p-8 md:p-12 text-center relative shadow-gold-glow-lg overflow-hidden" data-id="element-143">
          <div className="absolute top-0 left-0 w-full h-full bg-radial-gold opacity-30 pointer-events-none" data-id="element-144" />

          <ShieldCheck className="w-20 h-20 text-gold mx-auto mb-6 relative z-10" data-id="element-145" />

          <h2 className="text-3xl md:text-4xl font-black text-white mb-6 relative z-10" data-id="element-146">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-cream/90 text-lg relative z-10 max-w-xl mx-auto" data-id="element-147">
            <p data-id="element-148">Abrís los tomos. Los usás. Aplicás los protocolos.</p>
            <p data-id="element-149">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-150" />
              <span className="text-gold font-bold text-xl" data-id="element-151">
                devolución del 100%
              </span>
              <br data-id="element-152" />
              sin formularios, sin drama.
            </p>
            <p className="text-sm mt-6 pt-6 border-t border-gold/20" data-id="element-153">
              Solo escribinos a{' '}
              <span className="text-white font-medium" data-id="element-154">
                soporteavanzapro@gmail.com
              </span>{' '}
              dentro de los 7 días y gestionamos el reembolso completo.
            </p>
            <p className="text-xs text-cream/50 uppercase tracking-widest mt-4" data-id="element-155">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}